import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { viewBox: "0 0 3.175 4.145" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1.65 3.27a.132.132 0 00-.125 0l-1.393.743V.564c0-.117.044-.228.12-.308A.38.38 0 01.529.132h2.117a.38.38 0 01.277.124c.076.08.12.191.12.308v3.449z",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  fill: "none",
  "stroke-width": ".26458"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }